<template>
<div>
  
</div>
</template>


<script >
import Vue from 'vue';
import ChatCommon from '../mixins/chatcommon.vue';

export default Vue.extend({
  mixins: [ChatCommon],
  props: ['group'],
  data: function() {
    return {
      
    }
  },
  computed: {
   
  },
  methods: {
    
    
  },
  mounted() {
    console.log('chat menu mounts');
    console.log(this.group);
  },
  components: {

  },
})
</script>
